var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277.243,
    height: 89.064,
    viewBox: "0 0 277.243 89.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5238",
    "data-name": "Group 5238",
    transform: "translate(12981.235 1275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082",
    transform: "translate(-12937.057 -1275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M40.276,30.7V44.258H63.77v8.376H29.85V2.031H63.7v8.445H40.276V30.7Z",
    transform: "translate(-29.85 0.749)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M79.276,38.3l-3.615,3.615V53.383H65.617V0H75.661V29.575l1.946-2.5,9.627-11.3h12.06L85.705,31.452l14.771,21.931H88.937Z",
    transform: "translate(-17.309)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M93.344,5.813a4.948,4.948,0,0,1,1.511-3.719,6.517,6.517,0,0,1,8.22,0A4.918,4.918,0,0,1,104.6,5.813a4.933,4.933,0,0,1-1.547,3.753,6.442,6.442,0,0,1-8.166,0A4.932,4.932,0,0,1,93.344,5.813Zm10.67,47.335H93.935v-37.6h10.078Z",
    transform: "translate(-7.465 0.234)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M123.513,32.337l-5.422,5.839V52.634H107.665V2.031h10.426V24.969l4.588-6.291L135.573,2.031H148.4L130.429,24.517l18.488,28.116H136.511Z",
    transform: "translate(-2.611 0.749)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M162.382,49.319a11.157,11.157,0,0,1-1.007-3.371,12.155,12.155,0,0,1-9.488,4.067,13.344,13.344,0,0,1-9.157-3.2,10.282,10.282,0,0,1-3.631-8.064,10.627,10.627,0,0,1,4.431-9.175q4.433-3.2,12.806-3.232h4.622V24.192a6.2,6.2,0,0,0-1.337-4.171,5.265,5.265,0,0,0-4.224-1.565,5.976,5.976,0,0,0-3.978,1.217,4.133,4.133,0,0,0-1.444,3.337H139.932a10.09,10.09,0,0,1,2.016-6.047,13.34,13.34,0,0,1,5.7-4.362,20.782,20.782,0,0,1,8.272-1.581q6.954,0,11.036,3.493t4.082,9.818v16.3q.037,5.353,1.495,8.1v.59Zm-8.306-6.986a8.638,8.638,0,0,0,4.1-.991,6.5,6.5,0,0,0,2.78-2.658V32.218H157.2q-7.539,0-8.028,5.214l-.034.591a4.024,4.024,0,0,0,1.321,3.093A5.126,5.126,0,0,0,154.077,42.332Z",
    transform: "translate(8.471 4.064)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M189.2,21.133a27.37,27.37,0,0,0-3.615-.278q-5.7,0-7.472,3.857V49.319H168.068v-37.6h9.488l.278,4.483q3.024-5.178,8.376-5.178a10.522,10.522,0,0,1,3.128.452Z",
    transform: "translate(18.46 4.064)",
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M201.276,4.773v9.245H207.7v7.368h-6.429V40.153a4.484,4.484,0,0,0,.8,2.989,4.02,4.02,0,0,0,3.058.9,15.932,15.932,0,0,0,2.954-.244v7.612a20.676,20.676,0,0,1-6.082.9q-10.564,0-10.774-10.67V21.386H185.74V14.018h5.492V4.773Z",
    transform: "translate(24.977 1.76)",
    fill: "#30649B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5085",
    "data-name": "Group 5085",
    transform: "translate(-12981.235 -1251.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5084",
    "data-name": "Group 5084",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M81.187,52.6,28.552,51.522,15.585,31.61s-4.323-6.019,5.867-6.173c5.156-.078,53.555-.151,57.748-.2V17.03l-21.312-.092v.01H9.412S-1.393,16.177.151,28.525s17.286,32.722,21.3,35.191c58.5,3.4,60.815,3.86,60.815,3.86Z",
    transform: "translate(0 -16.938)",
    fill: "#ffda60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5083",
    "data-name": "Group 5083",
    transform: "translate(40.897 55.499)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.785,
    cy: 4.785,
    r: 4.785,
    fill: "#30649B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 4.785,
    cy: 4.785,
    r: 4.785,
    transform: "translate(20.992)",
    fill: "#30649B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M54.652,58.067v1.544H72.558l2.469-1.544Z",
    transform: "translate(20.155 -1.77)",
    fill: "#f9d341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M54.652,62.317h9.02l1.246-1.544H54.652Z",
    transform: "translate(20.155 -0.772)",
    fill: "#f9d341"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.dac99f08d31cea447c763ab7ec430d71.svg";
export { ForwardRef as ReactComponent };